<template>
    <v-dialog persistent :value="value" max-width="800px">
        <v-card>
            <v-card-title>
                <span class="text-h5">{{ $t('simple_img_dlg_title') }}</span>
            </v-card-title>

            <v-card-text>
                <v-form v-model="formIsValid">
                    <v-row dense>
                        <v-col cols="12">
                            <LabelField :label="$t('copyright')">
                                <v-text-field
                                    :value="imageRecord.credits"
                                    dense
                                    outlined
                                    :placeholder="`${year} Vincent Van Gogh`"
                                    prepend-inner-icon="ic-16 ic-copyright ic-col-black"
                                    @input="onInput('credits', $event)"
                                />
                            </LabelField>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12">
                            <LabelField :label="$t('titel_alt')">
                                <v-text-field
                                    :value="imageRecord.title"
                                    dense
                                    outlined
                                    :placeholder="$t('alt_text_desc')"
                                    @input="onInput('title', $event)"
                                />
                            </LabelField>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12">
                            <LabelField :label="$t('caption')">
                                <v-textarea
                                    :value="imageRecord.caption"
                                    dense
                                    outlined
                                    rows="3"
                                    placeholder="Donec sed odio dui. Donec sed odio dui. Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Aenean eu leo quam."
                                    @input="onInput('caption', $event)"
                                />
                            </LabelField>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <slot name="actions">
                    <v-spacer></v-spacer>
                    <PlainBtn @click="cancel">
                        <span>{{ $t('cancel') }}</span>
                    </PlainBtn>
                    <ActionBtn @click="save">
                        <KpIcon icon-cls="save" color="white" />
                        <span>{{ $t('save') }}</span>
                    </ActionBtn>
                </slot>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { Image } from '@/models/Image';

export default {
    name: 'SimpleImageDetailDlg',
    props: {
        value: Boolean,
        imageRecord: {
            type: Image,
            required: true,
        },
    },
    data() {
        return {
            formIsValid: true,
            year: new Date().getFullYear(),
        };
    },
    methods: {
        onInput(field, value) {
            this.imageRecord.set(field, value);
        },
        cancel() {
            this.imageRecord.reset();
            this.$emit('input', false);
        },
        save() {
            this.$emit('save');
        },
    },
};
</script>

<style></style>
